import React from 'react';
import { UseFormRegister, UseFormWatch } from 'react-hook-form';
import { RadioInput } from 'components/form';
import { QUESTION_CARD, QUESTION_TITLE, QUESTION_OPTIONS } from '../card-classes';

interface Option {
  label: string;
  value: string;
}

interface QuestionSingleRadioProps {
  register: UseFormRegister<any>;
  watch?: UseFormWatch<any>;
  errors: any;
  name: string;
  options: Option[];
  questionText: string;
  questionNumber: number;
  containerClassName?: string;
  titleClassName?: string;
  radioContainerClassName?: string;
}

export const QuestionSingleRadio: React.FC<QuestionSingleRadioProps> = ({
  register,
  watch,
  errors,
  name,
  options,
  questionText,
  questionNumber,
  containerClassName,
  titleClassName,
  radioContainerClassName,
}) => {
  const currentValue = watch ? watch(name) : undefined;
  
  return (
    <div className={`${QUESTION_CARD} ${containerClassName}`}>
      <h3 className={`${QUESTION_TITLE} ${titleClassName}`}>
        {questionNumber}. {questionText}
      </h3>
      <RadioInput
        register={register}
        name={name}
        options={options}
        type="radio"
        parentClassName={`${QUESTION_OPTIONS} ${radioContainerClassName}`}
        validatorMessage={errors?.[name]?.message}
        value={currentValue}
      />
    </div>
  );
};